export default __webpack_public_path__ + "static/media/meslay7.3ef1ba25.jpg";